import { Flex } from "@mantine/core";
import { type UseFieldArrayReturn } from "react-hook-form";

import CabinItem from "./CabinItem";

interface ICabinForm {
  cabins: Array<{ name: string }>;
}

type Props = Omit<UseFieldArrayReturn<ICabinForm>, "append">;

const CabinList = ({ fields, remove }: Props) => {
  return (
    <Flex w="100%" direction="column" align="center" mt="md">
      {fields.map((cabin, index) => (
        <CabinItem
          key={cabin.id}
          id={`cabins.${index}.name`}
          remove={() => remove(index)}
        />
      ))}
    </Flex>
  );
};

export default CabinList;
